require('./js/tagungen/tagungen');
